<template>
  <div class="devices">
    <admin-device-pop-up
      v-if="popup"
      :deviceId="deviceId"
      @close-popup="closePopup"
      @updated-driver="updatedDriver"  
    ></admin-device-pop-up>
    <div class="devices__content" v-else>
      <h1 class="devices__header" >Devices</h1>
      <div class="devices__table-content">
        <div class="devices__search-content">
          <div class="devices__per-page-container">
            <label>Show rows</label>
            <base-select :items="pageSelectItems" v-model="perPage" />
          </div>      
          <base-search
            :searchArr="devicesSearch"
            :fieldsString="[0, 1, 3, 4, 5, 6, 7, 8, 9]"
            :fieldsNumber="[]"
            :fieldsExtra="[1, 3, 4, 7, 8, 9]"
            @search="search"
          />
        </div>
        <base-table
          :columns="devicesColumns"
          :data="devices"
          :currentPage="devicesNumberPage"
          :perPage="perPage"
          @row-click="selectDevice"
        >
          <template #cell-driver="data">
            <div v-html="data.column.driver"></div>
          </template>
          <template #cell-worked="data">
            <div v-html="data.column.worked"></div>
          </template>
          <template #cell-last_online="data">
            <div v-html="data.column.last_online"></div>
          </template>
          <template #cell-alerts="data">
            <div v-html="data.column.alerts"></div>
          </template>
          <template #cell-status="data">
            <indicator-status :isActiveStatus="data.column.active" />
          </template>
        </base-table>
          
        <paginate
          v-if="devices.length > 0"
          v-model="devicesNumberPage"
          :page-count="devicesTotalPage"
          :container-class="'paginationContainer'"
          :active-class="'paginationActive'"
        >
        </paginate>
      </div>
    </div>
  </div>
</template>

<script>
import BaseTable from '@/components/common/BaseTable.vue'
import toast from '@utils/toast.js'
import BaseSearch from '@/components/common/BaseSearch.vue'
import BaseSelect from '@/components/common/BaseSelect.vue'
import AdminDevicePopUp from '@/components/admin/AdminDevices/AdminDevicePopUp.vue'
import IndicatorStatus from '@/components/common/IndicatorStatus.vue'

export default {
  name: 'AdminDevices',
  components: { BaseTable, BaseSearch, BaseSelect, AdminDevicePopUp, IndicatorStatus },
  
  data() {
    return {
      popup: false,
      perPage: 5,
      devicesSearch: [],
      devices: [],
      deviceId: '',
      devicesNumberPage: 1,
    }
  },
  computed: {
    pageSelectItems() {
      return [
        {value: 5, label: '5'},
        {value: 10, label: '10'},
        {value: 25, label: '25'},
        {value: this.devices.length, label: 'All'},
      ];
    },
    devicesColumns() {
      return [
        { label: 'DEVICE ID', value: 'id', sortable: true },
        { label: 'MANUFACTURER ID', value: 'manufacturer_id', sortable: true },
        { label: 'DRIVER', value: 'driver', sortable: true },
        { label: 'SIDE', value: 'side', sortable: true },
        { label: 'ACTIVATED', value: 'activated', sortable: true },
        { label: 'WORKED', value: 'worked', sortable: true },
        { label: 'LAST ONLINE', value: 'last_online', sortable: true },
        { label: 'STATUS', value: 'status', sortable: true },
        { label: 'ALERTS', value: 'alerts', sortable: true },
      ]
    },
    devicesTotalPage() {
      return Math.ceil(this.devices.length / this.perPage);
    },
  },
  async mounted() {
    await this.getDevices()
  },
  methods: {
    async getDevices () {
      try {
        const response = await this.request('/admin/list/devices', 'POST')
        if (response.code === 0) {
          toast.successMessage('Data is received')

          this.devices = response.data
          this.devicesSearch = this.devices

        } else {
          toast.errorMessage(response.message)
        }
      } catch (e) {
        toast.errorMessage(error)
      }
    },

    search(value) {
      this.devices = value
    },

    selectDevice(device) {
      this.deviceId = device.id
      this.popup = true
    },

    closePopup() {
      this.popup = false
    },
    async updatedDriver() {
      await this.getDevices()
      this.closePopup()
      toast.successMessage('Devace updated')
    }
 
  }

}
</script>

<style>

.devices {
  width: 100%;
  overflow: hidden;
}

.devices__content {
  text-align: left;
  padding: 20px;
}

.devices__header {
  margin-top: 59px;
}

.devices__table-content {
  margin-top: 58px;
}

.devices__search-content {
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
  width: 100%;
}

.devices__per-page-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 345px;
}

@media only screen and (max-width: 930px){
  .devices__search-content {
    flex-direction: column;
    height: 80px;
  }
}

@media only screen and (max-width: 730px){
  .paginationContainer {
    justify-content: flex-start;
    padding: 0;
  }

}

@media only screen and (max-width: 385px){
  .devices__per-page-container {
    flex-direction: column;
    align-items: flex-start;
    height: 60px;
    width: auto;
  }
  .devices__search-content {
    height: 140px;
  }
}

</style>